

















import { Component } from "vue-property-decorator";
import { DealAttachmentJson } from "@/models/filebunker/deal";
import { AttachmentViewModel } from "@/models/fixedops/attachment";
import VueUploadComponent from "vue-upload-component";
import { NewFaxViewModel } from "@/models/telephony/message";
import { VHeaders } from "@/models/pagedlistmodel";
import { ConversationTypes } from "@/enums/enums";
import { Base } from "@/components/common/base";
import { PaginationModel, VAction } from "@/models/pagedlistmodel";
import { accountReceivableService, attachmentService } from "@/shared";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    pages() {
      return this.pagedDeals.totalPages;
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    EmailAttachment: () => import("@/components/common/email.attachment.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    FileUpload: VueUploadComponent,
  },
})
export default class ChargeCustomerReceiptsPage extends Base {
  public loading: boolean = false;
  public attachments: DealAttachmentJson[] = [];
  public customerKey: string = "";
  public chargeCustomerGuid: string = "";
  public isPublic: boolean = false;
  public pagination: PaginationModel = new PaginationModel(
    "attachmentTypeName"
  );

  public faxToSend: NewFaxViewModel = new NewFaxViewModel(
    ConversationTypes[ConversationTypes.Fax]
  );

  public actions: any[] = [
    {
      type: "button",
      icon: "fas fa-eye",
      title: this.$parent.$t(
        "chargeCustomerAttachments.attachmentHeaders.gridAction.openAttachment"
      ) as string,
      loading: false,
      action: (model: AttachmentViewModel, action: VAction) => {
        if (model.attachmentTypeName == "Square Reciept") {
          window.open(model.uri, "_blank");
        } else {
          this.openAttachment(model.attachmentId, action);
        }
      },
    },
  ];
  public headers: VHeaders[] = [
    {
      text: this.$parent.$t(
        "chargeCustomerAttachments.attachmentHeaders.attachmentType"
      ) as string,
      align: "left",
      value: "attachmentTypeName",
    },
    {
      text: this.$parent.$t(
        "chargeCustomerAttachments.attachmentHeaders.uploadedAt"
      ) as string,
      align: "left",
      value: "createdAt",
      fieldType: "date",
    },
    {
      text: this.$parent.$t(
        "chargeCustomerAttachments.attachmentHeaders.comments"
      ) as string,
      align: "left",
      value: "comment",
    },
    {
      text: this.$parent.$t(
        "chargeCustomerAttachments.attachmentHeaders.isPublic"
      ) as string,
      align: "left",
      value: "isPublic",
      fieldType: "switch",
      onChange: (item: any): void => {
        if (item.isPublic) {
          this.togglePublic(item.attachmentId, true);
        } else {
          this.togglePublic(item.attachmentId, false);
        }
      },
      title: (item: any): string => {
        if (item) {
          return item.isPublic
            ? (this.$parent.$t("chargeCustomerAttachments.public") as string)
            : (this.$parent.$t(
                "chargeCustomerAttachments.notPublic"
              ) as string);
        }
      },
      disabled: (item: any): boolean => {
        return (
          item.attachmentTypeName === "Deal Document" ||
          item.attachmentTypeName === "File Bunker" || 
          item.attachmentTypeName === "Square Reciept"
        );
      },
    },
    {
      text: this.$parent.$t(
        "chargeCustomerAttachments.attachmentHeaders.action"
      ) as string,
      align: "center",
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "backToList") {
      this.backToList();
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "0",
      type: "button",
      title: this.$t("chargeCustomerAttachments.btnBackToListtitle"),
      disabled: false,
      visible: true,
      class: "btn",
      label: this.$t("chargeCustomerAttachments.btnBackToList"),
      click: "backToList",
      icon: "fas fa-arrow-left",
      requestProgress: true,
    });
    this.$emit("updateToolBar", buttons);
  }
  public mounted(): void {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "customerCharges");

    // Toolbar
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.chargeCustomerGuid = this.$route.params.chargeCustomerGuid;
    this.customerKey = this.$route.params.customerkey;
    this.getAttachments(this.chargeCustomerGuid);
  }

  public async getAttachments(chargeCustomerGuid: string): Promise<void> {
    try {
      this.loading = true;
      const attachments = await accountReceivableService.getAttachmentsAsync(
        this.chargeCustomerGuid,
        true
      );
      this.attachments = attachments.results;
    } finally {
      this.loading = false;
    }
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: "app.customercharges" });
    }
  }

  public async openAttachment(
    attachmentId: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
    }
  }

  public async togglePublic(id: string, status: boolean): Promise<void> {
    await attachmentService.toggleIsPublicAsync(id, status);
    this.showAlert(
      true,
      this.$t("chargeCustomerAttachments.attachmentUpdated")
    );
  }
}
